import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

//Add types for inputs later.
export const CreateItemAddress_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/addressController/player/CreateItem/Address',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/addressController/player/CreateItem/Address'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const UpdateItemAddress_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/addressController/player/UpdateItem/Address',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/addressController/player/UpdateItem/Address'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const DeleteItemAddress_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/addressController/player/DeleteItem/Address',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/addressController/player/DeleteItem/Address'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetItemAddress_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/addressController/player/GetItem/Address',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/addressController/player/GetItem/Address'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetListAddress_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/addressController/player/GetList/Address',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/addressController/player/GetList/Address'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
